/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IGlobalState } from './global';

const initialState: IGlobalState = {
  showLoginDialog: false,
  showSignupDialog: false,
  showForgetPasswordDialog: false,
};

const globalSlice = createSlice({
  name: 'global',
  initialState,
  reducers: {
    setShowLoginDialog: (state, action: PayloadAction<boolean>) => {
      state.showLoginDialog = action.payload;
    },
    setShowSignupDialog: (state, action: PayloadAction<boolean>) => {
      state.showSignupDialog = action.payload;
    },
    setShowForgetPasswordDialog: (state, action: PayloadAction<boolean>) => {
      state.showForgetPasswordDialog = action.payload;
    },
  },
});

export const {
  setShowLoginDialog,
  setShowSignupDialog,
  setShowForgetPasswordDialog,
} = globalSlice.actions;

export default globalSlice.reducer;

export const selectShowLoginDialog = (state: IGlobalState) =>
  state.showLoginDialog;
export const selectShowSignupDialog = (state: IGlobalState) =>
  state.showSignupDialog;
export const selectShowForgetPasswordDialog = (state: IGlobalState) =>
  state.showForgetPasswordDialog;
